import {
  Box,
  Switch,
  Typography
} from '@mui/material';
import Drawer from '@mui/material/Drawer';
import React from 'react';
import {
  Column,
  SimpleTable
} from '../../../../components/SimpleTable';
import {
  useOrganizationUserPermissionDrawerState,
  UserPermissionEntry
} from '../state/organization-user-permission-drawer-state';

type Props = {
  userName: string | null
  userId: string
  isDrawerOpen: boolean
  onDrawerClosed: () => void
}

export const OrganizationUserPermissionDrawer = ({userName, userId, isDrawerOpen, onDrawerClosed}: Props) => {
  const state = useOrganizationUserPermissionDrawerState(userId)

  const columns: Column<UserPermissionEntry>[] = [
    { key: 'permission', minWidth: 200, label: state.translateLocal('column.permission'), render: (row) => state.translate(`user.permission.${row.permission}`) },
    { key: 'active', minWidth: 200, label: state.translateLocal('column.active'), render: (row) => {
        const isPermissionActive = row.active

        return <Switch
          checked={isPermissionActive}
          onChange={async () => {
            isPermissionActive
              ? await state.deletePermission(row.permission)
              : await state.createPermission(row.permission)
          }}
          color="primary"
        />
    }},
  ]

  const buildHeader = () =>     <Box mb={2}>
    <Typography variant="subtitle1" component="span">
      {state.translateLocal('title')}{' '}
    </Typography>
    {userName && (
      <Typography
        variant="subtitle1"
        component="span"
        fontWeight={600}
      >
        {userName}
      </Typography>
    )}
  </Box>

  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: '50%',
        marginTop: '64px',
        height: `calc(100% - 64px)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    {buildHeader()}
    <SimpleTable
      rows={state.permissions.sort((a, b) => a.permission.localeCompare(b.permission))}
      columns={columns}
      rowKey={(row) => row.permission}
    />
  </Drawer>
}